<template>
    <div class="home-page">
		<Header></Header>
		<div class="list" v-if="!notFound">
			<div class="nav flex">
				<div class="back" @click="back">
					<img src="static/images/return.png" />
				</div>
				<span class="">{{$t('Question_List')}}</span>
			</div>
			<div class="section-list">
				<div class="list-t fs26 flex flex-between">
					<div class="">{{$t('Question_ID')}}</div>
					<div class="w70 ac">{{$t('Question_Status')}}</div>
				</div>
				<div class="section-content">
					<div class="font-c bgf7f flex-between flex"  v-for="(item,index) in list">
						<div class=" fs33">{{item.code}}</div>
						<div class="" @click="answers(item.status,item.id)">
							<p class="title fs26 text-overflow2" v-if="item.status=='0'">{{$t('Questions_are_answered')}}</p>
							<p class="title fs26 text-overflow2" v-if="item.status=='1'||item.status=='2'">{{$t('Questions_are_not_answered')}}</p>
						</div>
						<div class="next" @click="answers(item.status,item.id)">
							<img src="static/images/next.png" />
						</div>
					</div>
				</div>
			</div>
			<div class="mt50 fs33 crff1d4f ac more">
				<span @click="getMore">+{{$t('more')}}</span>
			</div>
			<div class="mt50 flex flex-center">
				<div class="btn crff1d4f fs46" @click="answers">
					{{$t('Continue')}}
				</div>
				<div class="btn crff1d4f fs33" @click="buyAnswer(1)">
					+ {{$t('Get_more_questions')}}
				</div>
			</div>
			<Dialog ref="buyTipsDialog" title="" type="alert" :modalFoot="modalFoot" :cancelText="$t('No')">
				<div slot="mdBox" >
					<div class="ac fs33" v-if="info.today_last_num>0">
							<div class="tips" style="padding:30px 0 20px" v-if="lang=='en'">{{info.alert_msg1}}</div>
							<div class="tips" style="padding:30px 0 20px" v-else>{{info.alert_msg1_mm}}</div>
						<div class="modal-footer ac">
							<button class="btn btn-none" @click="buyAnswer(3)">{{$t('cancel')}}</button>
							<button class="btn btn-blue" id="closeModal" @click="buyAnswer(2)">{{$t('Confirm')}}</button>
						</div>
					</div>
					<div class="ac fs33" v-if="info.today_last_num==0">
						<div class="tips" style="padding:30px 0 20px" v-if="lang=='en'">{{info.alert_msg2}}</div>
						<div class="tips" style="padding:30px 0 20px" v-else>{{info.alert_msg2_mm}}</div>
						<div class="modal-footer ac">
							<button class="btn btn-none" id="closeModal" @click="buyAnswer(3)">{{$t('OK')}}</button>
						</div>
					</div>
				</div>
			</Dialog>

			<Dialog ref="saveDialog2" :callback="tips2Modal" title="" type="alert" :btnText="$t('Yes')" cancelText="">
				<div slot="mdBox" >
					<div class="ac fs33">
						<div class="radio-div">
							{{$t('tips2')}}
						</div>
					</div>
				</div>
			</Dialog>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
		Dialog
    },
    data() {

        return {
			notFound:false,
			list:[],
			info:{},
			page_id:1,
			page_size:10,
			modalFoot:false,
			isShow:true,
      lang:'en'

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
    if(localStorage.getItem('lang')){
      this.lang = localStorage.getItem('lang')
    }else{
      this.lang = 'en'
    }
		this.getHome();
	},
    methods: {
		back(){
			this.$router.push({path:'/'})
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {
				'token':localStorage.getItem('token'),
				uuid:localStorage.getItem('uuid'),
				page_id:that.page_id,
				page_size:that.page_size,
			}
			that.$api.get('/user/list',data,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.$parent.loadModal(false);
					if(that.page_id>1){
			      if(r.data.list.length>0){
			        that.list = that.list.concat(r.data.list)
			      }else{
			        console.log(222)
			        that.isShow = false;
			        that.$utils.alertText(that.$t('noMore'));
			        that.page_id = 1
			      }
					}else{
			      that.list = r.data.list
			      that.isShow = true;
					}

			  });

			})
		},
		getMore(){
			let that = this;
			if(that.isShow){
				that.page_id++;
				that.getHome();
			}else{
				that.$utils.alertText(that.$t('noMore'));
			}
		},
		tips2Modal(){
			this.$refs.saveDialog2.closeMask();
		},
		//购买
		buyAnswer(type){
			let that =this;
			if(type==1){
				that.$refs.buyTipsDialog.showMaskFun();
			}else if(type==2){
				that.$refs.buyTipsDialog.closeMask();
				that.$parent.loadModal(true);
				let data = {
					'token':localStorage.getItem('token'),
					uuid:localStorage.getItem('uuid')
				}
				that.$api.post('/user/buy',data,r =>{
					if(r.code==401){
						that.$refs.saveDialog2.showMaskFun();
					}
					that.$parent.returnCode(r,function(){
						that.$utils.alertText(r.msg,80);
						that.getHome();
						that.$parent.loadModal(false);
					});

				})
			}else{
				that.$refs.buyTipsDialog.closeMask();
			}

		},
		answers(type,id){
			if(type==0){
				this.$router.push({path:'/answeredList',query: {id:id}})
			}else if(type==1||type==2){
				this.$router.push({path:'/answer',query: {id:id}})
			}else{
				this.$router.push({path:'/answer'})
			}

		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/list.vue